import React from 'react';
import { CSSTransition } from 'react-transition-group';

import PropTypes from 'prop-types';

import styles from './HingeFadeInFromTop.module.scss';

const HingeFadeInFromTop = ({ children, visible, timeout, ...props }) => {
    return (
        <CSSTransition
            classNames={styles['HingeFadeInFromTop']}
            in={visible}
            timeout={timeout}
            enter={true}
            unmountOnExit
            {...props}>
            {children}
        </CSSTransition>
    );
};

HingeFadeInFromTop.propTypes = {
    children: PropTypes.node,
    visible: PropTypes.bool,
    timeout: PropTypes.number,
};

HingeFadeInFromTop.defaultProps = {
    children: '',
    visible: false,
    timeout: 300,
};

export default HingeFadeInFromTop;
